import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-lazy-iframe]';
export const PLUGIN_NAME = 'lazyIframe';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
	const element = this;
	System.import(/* webpackChunkName: "component--lazy-iframe" */ './lazy-iframe').then(() => {
        $(element)[PLUGIN_NAME]();
    });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/lazy-iframe/index.js